export enum mapBaseUrl {
    GoogleMapActionSearch = 'https://www.google.com/maps/search/?api=1',
}
